import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleResponse from "./refundVehicleDetailResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RefundChargeDetailResponse {
  @observable
  @Type(() => VehicleResponse)
  vehicle!: VehicleResponse;

  @observable
  chargeTypeId!: string;

  /**
   * Price list item Id.
   */
  @observable
  priceListItemId!: string;

  @observable
  @Type(() => Date)
  validSince!: Date;

  @observable
  @Type(() => Date)
  validUntil!: Date;

  @observable
  price!: number;
}
